import { render } from "./COVIDMaskLayout.vue?vue&type=template&id=02c1a609&scoped=true&ts=true"
import script from "./COVIDMaskLayout.vue?vue&type=script&lang=ts"
export * from "./COVIDMaskLayout.vue?vue&type=script&lang=ts"

import "./COVIDMaskLayout.vue?vue&type=style&index=0&id=02c1a609&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c1a609"]])

export default __exports__